var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRecordContext, useGetList } from "react-admin";
import { Chip, Stack } from "@mui/material";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { useTranslation } from "react-i18next";
import { AUTHORIZED_ELECTION_IDS } from "./ListUsers";
export var AuthorizedElectionsField = function (_a) {
    var _b, _c;
    var electionEventId = _a.electionEventId;
    var t = useTranslation().t;
    var record = useRecordContext();
    var aliasRenderer = useAliasRenderer();
    var ids = (_c = (_b = record === null || record === void 0 ? void 0 : record.attributes) === null || _b === void 0 ? void 0 : _b[AUTHORIZED_ELECTION_IDS]) !== null && _c !== void 0 ? _c : [];
    var enabled = !!electionEventId && ids.length > 0;
    var data = useGetList("sequent_backend_election", {
        filter: {
            election_event_id: electionEventId,
            alias: {
                format: "hasura-raw-query",
                value: { _in: ids },
            },
        },
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
    }, { enabled: enabled }).data;
    if (!enabled)
        return null;
    return (_jsx(Stack, __assign({ direction: "row", spacing: 1, useFlexGap: true, flexWrap: "wrap" }, { children: data === null || data === void 0 ? void 0 : data.map(function (e) {
            var _a;
            return (_jsx(Chip, { label: (_a = aliasRenderer(e)) !== null && _a !== void 0 ? _a : "" }, e.id));
        }) })));
};
